import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'

export default function RejectKyc() {
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);
    const [numberOfPages, setNumberOfPages] = useState(0);

    // --- IMAGE PREVIEW STATE ---
    const [previewImage, setPreviewImage] = useState(null);

    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    let baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;
    if (baseUrl && !baseUrl.endsWith('/')) {
        baseUrl += '/';
    }

    const setpageLimit = (event) => {
        setLimit(event.target.value);
        setPageNumber(0);
    }

    const handlePageClick = (data) => {
        setPageNumber(data.selected);
    };

    const All = () => {
        const access_token = localStorage.getItem("token")
        const headers = { Authorization: `Bearer ${access_token}` }
        axios.get(`${baseUrl}aadharcard/all/all/reject?page=${pageNumber + 1}&_limit=${limit}`, { headers })
            .then((res) => {
                setData(res.data.admin || [])
                setNumberOfPages(res.data.totalPages || 0)
            })
    }

    const dateFormat = (e) => {
        const date = new Date(e);
        return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
    }

    useEffect(() => {
        All()
    }, [pageNumber, limit])

    return (
        <div className="reject-kyc-container p-4">
            <style>{`
                .reject-kyc-container { background: #f0f2f5; min-height: 100vh; font-family: 'Poppins', sans-serif; }
                .header-card { background: #fff; padding: 25px; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); margin-bottom: 30px; }
                
                .kyc-table-card { background: #ffffff; border-radius: 25px; overflow: hidden; box-shadow: 0 15px 35px rgba(0,0,0,0.1); border: none; }
                .table-banner-reject { background: linear-gradient(45deg, #be123c, #991b1b); color: #ffffff !important; padding: 18px 25px; font-weight: 700; font-size: 1.1rem; }
                
                .custom-table-reject { width: 100%; border-collapse: collapse; table-layout: fixed; }
                .custom-table-reject th { background: #f8f9fa; color: #333 !important; padding: 15px 10px; font-weight: 800; text-transform: uppercase; font-size: 0.7rem; border-bottom: 2px solid #edf2f7; text-align: center; }
                .custom-table-reject td { padding: 15px 10px; vertical-align: middle; border-bottom: 1px solid #f1f1f1; font-size: 0.85rem; color: #000 !important; text-align: center; word-break: break-word; font-weight: 500; }
                .custom-table-reject tbody tr:hover { background-color: #fff1f2; }

                .kyc-thumb { width: 45px; height: 45px; object-fit: cover; border-radius: 8px; cursor: pointer; border: 2px solid #e2e8f0; transition: 0.3s; }
                .kyc-thumb:hover { transform: scale(1.15); border-color: #be123c; }
                
                .status-badge-rejected { background: #fee2e2; color: #991b1b !important; padding: 6px 12px; border-radius: 10px; font-weight: 800; font-size: 0.7rem; text-transform: uppercase; }
                
                /* MODAL OVERLAY */
                .preview-modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.9); display: flex; justify-content: center; align-items: center; z-index: 9999; animation: fadeIn 0.2s ease-in; }
                .modal-image-box { position: relative; max-width: 90%; max-height: 90%; }
                .modal-image-box img { max-width: 100%; max-height: 80vh; border-radius: 12px; box-shadow: 0 0 40px rgba(255,255,255,0.1); }
                .btn-close-preview { position: absolute; top: -50px; right: 0; color: #fff; font-size: 40px; cursor: pointer; background: none; border: none; outline: none; }
                
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

                .pagination-reject .page-link { border-radius: 10px !important; margin: 0 4px; border: none; background: #fff; color: #1e293b; font-weight: 600; box-shadow: 0 2px 5px rgba(0,0,0,0.05); }
                .pagination-reject .page-item.active .page-link { background: #be123c !important; color: #fff !important; }
            `}</style>

            <div className="header-card">
                <h2 style={{fontWeight: 900, color: '#2d3436', margin: 0}}>Rejected <span style={{color: '#be123c'}}>KYC Records</span></h2>
                <p className="text-muted m-0">View all players whose identification documents were declined</p>
            </div>

            <div className="row mb-4 align-items-center">
                <div className="col-md-2">
                    <select className='form-control' style={{borderRadius: '12px', fontWeight: 'bold', border: '2px solid #edf2f7'}} onChange={setpageLimit}>
                        <option value="10">Limit: 10</option>
                        <option value="20">Limit: 20</option>
                        <option value="50">Limit: 50</option>
                    </select>
                </div>
            </div>

            <div className="kyc-table-card">
                <div className="table-banner-reject">🚫 KYC Rejection History</div>
                <div className="table-responsive">
                    <table className="custom-table-reject">
                        <thead>
                            <tr>
                                <th style={{width: '50px'}}>#</th>
                                <th style={{width: '180px'}}>Profile Name</th>
                                <th style={{width: '150px'}}>Doc Name</th>
                                <th style={{width: '130px'}}>Phone</th>
                                <th style={{width: '150px'}}>Aadhar No</th>
                                <th style={{width: '110px'}}>DOB</th>
                                <th style={{width: '100px'}}>Front</th>
                                <th style={{width: '100px'}}>Back</th>
                                <th style={{width: '120px'}}>Status</th>
                                <th style={{width: '130px'}}>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.map((item, index) => (
                                <tr key={index}>
                                    <td style={{color: '#64748b', fontWeight: 'bold'}}>#{(pageNumber * limit) + (index + 1)}</td>
                                    <td>
                                        <Link className="btn btn-sm" style={{background: '#f8fafc', color: '#1e293b', fontWeight: '700', borderRadius: '8px', border: '1px solid #e2e8f0'}} to={`/user/view_user/${item.User?._id}`}>
                                            {item.User ? item.User.Name : 'N/A'}
                                        </Link>
                                    </td>
                                    <td style={{fontWeight: '700'}}>{item.Name}</td>
                                    <td style={{fontWeight: '600'}}>{item.User?.Phone}</td>
                                    <td style={{fontFamily: 'monospace', fontSize: '0.85rem', color: '#be123c !important', fontWeight: 'bold'}}>{item.Number}</td>
                                    <td>{item.DOB}</td>
                                    <td>
                                        <img 
                                            src={`${baseUrl}${item.front}`} 
                                            className="kyc-thumb" 
                                            alt="Front" 
                                            onClick={() => setPreviewImage(`${baseUrl}${item.front}`)}
                                        />
                                    </td>
                                    <td>
                                        <img 
                                            src={`${baseUrl}${item.back}`} 
                                            className="kyc-thumb" 
                                            alt="Back" 
                                            onClick={() => setPreviewImage(`${baseUrl}${item.back}`)}
                                        />
                                    </td>
                                    <td><span className="status-badge-rejected">{item.verified}</span></td>
                                    <td style={{fontSize: '0.75rem', color: '#64748b'}}>{dateFormat(item.createdAt)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='mt-4'>
                <ReactPaginate
                    previousLabel={"← Prev"}
                    nextLabel={"Next →"}
                    pageCount={numberOfPages}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination pagination-reject justify-content-center"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link shadow-sm"}
                    activeClassName={"active"}
                    forcePage={pageNumber}
                />
            </div>

            {/* --- IMAGE PREVIEW MODAL (IN-PAGE VIEW) --- */}
            {previewImage && (
                <div className="preview-modal-overlay" onClick={() => setPreviewImage(null)}>
                    <div className="modal-image-box" onClick={(e) => e.stopPropagation()}>
                        <button className="btn-close-preview" onClick={() => setPreviewImage(null)}>&times;</button>
                        <img src={previewImage} alt="Rejected KYC Document" />
                        <div className="text-center mt-3">
                            <a href={previewImage} download className="btn btn-outline-light btn-sm">Download for Record</a>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}